import { render, staticRenderFns } from "./CMMaxStudents.vue?vue&type=template&id=0fdd125a&scoped=true&lang=pug"
import script from "./CMMaxStudents.vue?vue&type=script&lang=js"
export * from "./CMMaxStudents.vue?vue&type=script&lang=js"
import style0 from "./CMMaxStudents.vue?vue&type=style&index=0&id=0fdd125a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdd125a",
  null
  
)

export default component.exports